// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import Distpicker from 'v-distpicker'
import axios from 'axios2'
import store from './vuex.js'
import Qs from 'qs'
import MtaH5 from 'mta-h5-analysis'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueQuillEditor)

Vue.component('v-distpicker', Distpicker)

Vue.prototype.global = global

// 全局变量
Vue.prototype.axios = axios
axios.interceptors.response.use(
  response => {
    return response
  }, error => {
    if (error.response.status === 401 || error.response.status === 403) {
      Message({
        showClose: true,
        message: '登录验证失败，请重新登录！',
        type: 'error'
      })
      setTimeout(() => {
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }, 1000)
    } else if (error.response && error.response.status === 500) {
      alert('发生错误，errorcode500')
    }
    return Promise.reject(error.response.data)
  }
)
axios.defaults.timeout = 30000
axios.interceptors.request.use(
  config => {
    if (localStorage.access_token) {
      config.headers['access_token'] = localStorage.access_token
	  config.headers['token'] = localStorage.access_token
    }
	if (localStorage.webid) {
	  config.headers['webid'] = localStorage.webid
	}
	if (localStorage.loginAccount) {
	  config.headers['username'] = localStorage.loginAccount
	}
    let contentType = config.headers['Content-Type']
    if (!contentType) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      config.data = Qs.stringify(config.data)
      return config
    }
    if (contentType.indexOf('json') > 0) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      config.data = JSON.stringify(config.data)
      return config
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.prototype.MtaH5 = MtaH5
Vue.prototype.formData = function (obj) {
  return obj
}

Vue.prototype.openFullScreen = function() {
  const dataLoadIng = this.$loading({
    lock: true,
    text: '',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  setTimeout(() => {
    dataLoadIng.close();
  }, 5000);
  return dataLoadIng;
}

Vue.prototype.unSetLocalStorage = function() {
  localStorage.now_code = ''
  localStorage.now_active_code = ''
  localStorage.now_shop_desc = ''
  localStorage.code = ''
  localStorage.dg_code = ''
  localStorage.del_goods_id = ''
  localStorage.edit_goods_id = ''
  localStorage.work_code = ''
  localStorage.edit_work_for_data = ''
  localStorage.qr_code = ''
}

//埋点函数
Vue.prototype.setHankMtaH5 = function (param) {
  console.log(param)
  this.MtaH5.clickStat(param)
}
Vue.prototype.setHankMtaH5LouDou = function (ldname,itemname) {
  let data = {}
  data[itemname] = 'true'
  this.MtaH5.clickStat(ldname, data)
}

Vue.prototype.getCookie = function (param) {
  let cparam = ''
  if (document.cookie.length > 0) {
    let arr = document.cookie.split('; ')
    for (let i = 0; i < arr.length; i++) {
      let arr2 = arr[i].split('=')
      if (arr2[0] === param) {
        cparam = arr2[1]
      }
    }
    if (cparam.indexOf('%7B') > -1) {
      return decodeURIComponent(cparam)
    }
    return cparam
  }
}

Vue.prototype.setCookie = function (name, value, path, expire) {
  let cookie = name + '=' + escape(value)
  if (expire) {
    let date = new Date()
    date.setSeconds(date.getSeconds() + expire)
    cookie = cookie + ';expires=' + date.toGMTString()
  }
  if (path) {
    cookie = cookie + ';path=' + path
  }
  document.cookie = cookie
}

Vue.prototype.getCart = function () {
  let value = new Array()
  if (localStorage.shopping_cart) {
    let valueStr = localStorage.shopping_cart
    if (valueStr) {
      try {
        value = JSON.parse(valueStr)
      } catch (e) {
        value = new Array()
      }
      if (!(value instanceof Array)) {
        value = new Array()
      }
    }
  }
  return value
}

Vue.prototype.setCart = function (value) {
  localStorage.shopping_cart = JSON.stringify(value)
  store.commit('setCartCount', value.length)
}

Vue.prototype.addToCart = function (good) {
  var value = this.getCart()
  var goods =
  {
    'goods_id': good.id,
    'num': 1,
    'price': good.price
  }

  if (value && value.length > 0) {
    var i = 0
    for (; i < value.length; i++) {
      var item = value[i]
      if (item.goods_id == good.id) {
        item.num++
        goods = item
        value.splice(i, 1)
        break
      }
    }
  }
  value.push(goods)

  this.setCart(value)
}

Vue.prototype.getArrayIndex = function (arrayObj, key, val) {
  for (let i = 0; i < arrayObj.length; i++) {
    if (arrayObj[i][key] === val) {
      return i
    }
  }
  return -1
}

Vue.prototype.DeleteFromCart = function (goodsId) {
  let value = this.getCart()
  console.log(value.length)
  let i = 0
  for (; i < value.length; i++) {
    let item = value[i]
    if (item.goods_id == goodsId) {
      value.splice(i, 1)
      this.setCart(value)
      break
    }
  }
}

Vue.prototype.subFromCart = function (goodsId) {
  var value = this.getCart()

  if (value) {
    var i = 0
    for (; i < value.length; i++) {
      var item = value[i]
      if (item.goods_id == goodsId) {
        item.num--
        if (item.num == 0) {
          value.splice(i)
          i--
        }

        this.setCart(value)
        break
      }
    }
  }
}

Vue.prototype.getUserInfo = function () {
  if (localStorage.userInfo) {
    return JSON.parse(localStorage.userInfo)
  }
  return []
}

Vue.prototype.toUrlParams = function (obj) {
  let res = ''
  if (Object.keys(obj).length > 0) {
    let array = []
    for (let i in obj) {
      array.push(i + '=' + obj[i])
    }
    res = array.join('&')
  }
  return res
}

/// Promise写法  this.axios 要在promise里面
Vue.prototype.httpPost = function (url, data, isJosn = false) {
  console.log(JSON.stringify(data))
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: isJosn ? data : this.toUrlParams(data),
      headers: {
        'Content-Type': isJosn ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded'
      }
    }).then((res) => {
      res.data.code === 0 ? resolve(res.data) : reject(res.data.msg)
    }).catch((res) => {
      console.log(res)
      reject(new Error(res))
    })
  })
}

// 粘贴版事件
Vue.prototype.copyToClipboard = function (text) {
  let callback = true

  var textArea = document.createElement("textarea")
  textArea.style.position = 'fixed'
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = '0'
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    callback = successful
  } catch (err) {
    callback = false
  }

  document.body.removeChild(textArea)

  return callback
}

Vue.prototype.getConfigType = function () {
  if (!localStorage.configStype) {
    localStorage.configStype = 1
    return 1
  }
  if (localStorage.configStype === 1 || localStorage.configStype === '1') {
    return 1
  }
  return 2
}

Vue.prototype.dengDengYu = function (x,y) {
  if (x === y) {
    return true
  }
  y += ''
  if (x === y) {
    return true
  }
  return false
}

Vue.prototype.resizedwindow = function () {
  (function(doc, win) {
    var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function() {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        docEl.style.fontSize = (clientWidth / 16) + 'px'
        console.log(clientWidth)
      }
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  })(document, window)
}
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js